import React from 'react'
import type { FC, ReactNode } from 'react'
import type { AlertProps } from '@material-ui/lab'
import { Alert, AlertTitle } from '@material-ui/lab'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&.MuiAlert-standardError': {
        border: '1px solid rgba(185,21,21,0.3)',
        borderRadius: 2,
        backgroundColor: 'rgba(185,21,21,0.05)',
      },
      '& .c-alert__message': {
        color: theme.colors.grey490,
        fontSize: theme.typography.pxToRem(14),
        letterSpacing: '-0.23px',
        lineHeight: theme.typography.pxToRem(22),
      },
    },
    title: {
      color: theme.colors.grey800,
      fontSize: theme.typography.pxToRem(21),
      letterSpacing: '-0.2px',
      lineHeight: theme.typography.pxToRem(26),
      fontWeight: 500,
      marginBottom: 15,
    },
    inner: {},
  }),
)

interface IProps extends AlertProps {
  title?: string
  children?: ReactNode
  className?: string
}

const CustomAlert: FC<IProps> = ({ title, children, className, ...rest }) => {
  const classes = useStyles()

  return (
    <Alert className={clsx(classes.root, className)} {...rest}>
      <div className={classes.inner}>
        <AlertTitle className={clsx(classes.title)}>{title}</AlertTitle>
        {children && children}
      </div>
    </Alert>
  )
}

export default CustomAlert
